import { Box, styled } from "@mui/material";

export const WidgetWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexGrow: 1,
  padding: "24px",
  border: `1px solid ${theme.palette.grey[300]}`,
  borderRadius: "10px",
}));
